import { render, staticRenderFns } from "./rm.vue?vue&type=template&id=9dc2cf96&"
import script from "./rm.vue?vue&type=script&lang=js&"
export * from "./rm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports